import { Component } from 'react'
import CollapsableList from '~/components/Dealers/CollapsableList'
import Octicon, { ChevronDown } from '@primer/octicons-react'
import styles from '~/styles/ordersPage.dealerSelect.module.css'
import types from '~/types/ordersPage.ts'

export default class DealerSelect extends Component {
	static getInitialProps() {
		return {
			namespacesRequired: [ 'Orders' ],
		}
	}
	
	public constructor(props) {
		super(props)
		this._dealers = {}
		this._defaultDealer = this.getDefaultDealer()
		this.state = {
			currentDealerName: this._defaultDealer.name,
			show: false,
		}
		if (this.props.setDealerSelectToBeClosed) {
			const cssQueries = [
				'div[class^="dealers_collapsableList__main"]',
				'div[class^="ordersPage_dealerSelect_main"]',
			]
			this.props.setDealerSelectToBeClosed(this._onHideDealers.bind(this), cssQueries) 
		}
	}
	
	public render(): JSX.Element {
		return (
			<div
				className={styles.main}
			>
				<div
					className={this.props.isDisabled ? styles.isDisabled : null}
					onClick={this._onShowDealers.bind(this)}
				>
					<div>
						{this.state.currentDealerName}
					</div>
					{this._getArrowDown()}
				</div>
				{this._showCollapsable()}
			</div>
		)
	}

	public getDefaultDealer() {
		let defaultDealer
		const shipper = this.props?.dealerAndChildDealers?.[this.props.order?.shipperId]
		if (shipper) {
			defaultDealer = shipper
		} else {
			Object.keys(this.props.dealerAndChildDealers || {}).some(dealerId => {
				const dealer = this.props.dealerAndChildDealers[dealerId]
				if (dealer.dealerType === 'isDefault') {
					let minLevel = dealer.level
					if (dealer.allParents?.length) {
						dealer.allParents.forEach(parentId => {
							const parent = this.props.dealerAndChildDealers[parentId]
							if (parent?.level < minLevel) {
								minLevel = parent.level
							}
						})
					}
					dealer.minLevel = minLevel
					defaultDealer = dealer
					return true
				}
			})
			if (!defaultDealer) {
				let dealer = this.props?.dealerAndChildDealers[this.props.order?.in_shop_id]
				if (!dealer) {
					const firstDealerId = Object.keys(this.props?.dealerAndChildDealers || {})?.[0]
					if (firstDealerId) {
						dealer = this.props?.dealerAndChildDealers[firstDealerId]
					}
				}
				defaultDealer = dealer
			}
			if (!defaultDealer) {
				defaultDealer = {
					id: this.props.order?.in_shop_id,
					name: this.props.order?.in_shop,
				}
			}
		}
		return defaultDealer
	}

	private _showCollapsable(): void {
		if (this.state.show) {
			return (
				<div>
					<CollapsableList
		                dealersObject={this.props.dealerAndChildDealers}
		                currentDealer={this._defaultDealer}
		                onDealerChange={this._onChange.bind(this)}
		                showNextLevel={true}
		                preventNotAllowed={true}
		                showCurrent={true}
		            />
		        </div>
			)
		} else {
			return null
		}
	}

	private _getArrowDown() {
		if (!this.props.isDisabled) {
			return (
				<div>
					<Octicon
						icon={ChevronDown}
					/>
				</div>
			)
		} else {
			return null
		}
	}

	private _onShowDealers(): void {
		if (!this.props.isDisabled) {
			this.setState({ show: true })
		}
	}

	private _onHideDealers(): void {
		this.setState({ show: false })
	}
		
	private _onChange(dealerId, dealer): void {
		this.setState({ 
			show: false,
			currentDealerName: dealer.name,
		})
		const isLengthByDefault = this.props.order.mu_in_length === this.props.order.defaultPackageLengthMu
		const isWidthByDefault = this.props.order.mu_in_width === this.props.order.defaultPackageWidthMu
		const isHeightByDefault = this.props.order.mu_in_height === this.props.order.defaultPackageHeightMu
		const isWeightByDefault = this.props.order.mu_in_weight === this.props.order.defaultPackageWeightMu
		const isByDefault = (isLengthByDefault && isWidthByDefault && isHeightByDefault && isWeightByDefault)
		const changes = {
			shipperId: dealerId,
			shipperName: dealer.name,
			defaultPackageLengthMu: dealer.defaultPackageLengthMu,
			defaultPackageWidthMu: dealer.defaultPackageWidthMu,
			defaultPackageHeightMu: dealer.defaultPackageHeightMu,
			defaultPackageWeightMu: dealer.defaultPackageWeightMu,
			currency: dealer.dealer_currency,
		}
		this.props.onChange(changes)
		setTimeout(() => {
			this.props.chargeableWeightUpdater(dealerId)
			this.props.refreshPoint()
			this.props.onShipperChanged(changes, isByDefault)
		})
	}
}